import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Row } from 'react-styled-flexboxgrid-tmp'

import NoResults from 'Components/NoResults'
import AgentPreview from 'Components/AgentPreview'
import WithSpinner from 'Components/WithSpinner'
import { MaxWidthGrid } from 'Layout'
import { isNilEmpty } from 'Utils'


const personPlaceholder = '/static/images/person_placeholder.webp'


const AgentGrid = (
  {
    isFetching,
    agents,
    loadAgentsPage,
    setTargetComponent = () => {},
    userCurrentArea,
    reloadAgentsData,
  },
) => {
  useEffect(() => {
    if(isNilEmpty(agents)) {
      loadAgentsPage()
    }
  }, [])
  useEffect(() => {
    reloadAgentsData()
  }, [userCurrentArea])


  // for now removing pagination component since localities endpoint does not
  // support pagination.
  // render agent Preview
  const renderPaginatedList = () => (
    <Row data-test-id="agentGridList">
      {
        agents && agents.map((item) => (
          <AgentPreview
            key={item.fullname}
            id={item.id}
            agent={item}
            image={(item.profile_image) ? item.profile_image.normal_path : personPlaceholder}
            fullname={item.fullname}
            brokerageName={item.brokerage_name}
            jobtitle={item.title || '-'}
            url={item.url}
            setTargetComponent={setTargetComponent}
          />
        ))
      }
    </Row>
  )

  const paginatedList = useMemo(() => renderPaginatedList({ agents, setTargetComponent }), [agents])
  const showAgents = agents && agents.length
  return (
    <WithSpinner timeout={200} showSpinner={!showAgents && isFetching}>
      <div>
        <MaxWidthGrid>
          {
            showAgents
              ? paginatedList
              : !isFetching && <NoResults />
          }
        </MaxWidthGrid>
      </div>
    </WithSpinner>
  )
}

AgentGrid.defaultProps = {
  reloadAgentsData: () => {},
}


AgentGrid.propTypes = {
  isFetching: PropTypes.bool,
  agents: PropTypes.arrayOf(PropTypes.shape({})), // .isRequired,
  loadAgentsPage: PropTypes.func.isRequired,
  // reloadAgentsData: PropTypes.func,
  userCurrentArea: PropTypes.shape({}),
  setTargetComponent: PropTypes.func,
  reloadAgentsData: PropTypes.func,
  areas: PropTypes.shape({
    label: PropTypes.string,
  }),
}

export default AgentGrid
